import React from 'react'

import { Edit as RaEdit, Create as RaCreate } from "react-admin";


export const Edit = props => <RaEdit undoable={false} {...props} className={"entity-form "+(props.resource+'-form')}  />
export const Create =props=> <RaCreate {...props} className={"entity-form "+(props.resource+'-form')}  />